import getAxios, { getLangFromUrl, getWrapper } from './axios'
import { formDataToRequestParams } from './helpers'
import {
    EmphemeralListTypings,
    EmphemeralPostType,
    EphemeralUploadVideoPayload,
    EphemeralUploadVideoPayloadGet,
    EphemeralUploadVideoPayloadListPayload,
    LikeListPayload,
    LikeResponse,
    SubmitEphemeral,
    UpdatePost,
    UploadPhotoPayload
} from '../store/ephemeral/ephemeralTypings'
import { UploadContributionMaterial } from '../store/contributions/contributionsTypings'

export const getEphemeralList = (params: { limit?: number; offset?: number }): Promise<EmphemeralListTypings> => {
    return getWrapper('/ephemeral/list', { params }) as Promise<EmphemeralListTypings>
}

export const getComments = (id: number, offset: number): Promise<EmphemeralListTypings> => {
    return getWrapper(`/ephemeral/comments?id=${id}&offset=${offset}`) as Promise<EmphemeralListTypings>
}

export const deleteComment = (id: number): Promise<LikeResponse> => {
    return getWrapper(`/ephemeral/comment/delete/?id=${id}`) as Promise<LikeResponse>
}

export const getEphemeralPost = (id: string | number): Promise<EmphemeralPostType> => {
    return getWrapper(`/ephemeral/get?id=${id}`) as Promise<EmphemeralPostType>
}

export const getEphemeralListLikes = (params: {
    id: number
    limit?: number
    offset?: number
}): Promise<LikeListPayload> => {
    return getWrapper('/ephemeral/list/likes', { params }) as Promise<LikeListPayload>
}

export const uploadPhoto = (params: SubmitEphemeral): Promise<UploadPhotoPayload> => {
    return getWrapper(
        '/ephemeral/submit/',
        formDataToRequestParams<SubmitEphemeral>(params),
        true
    ) as Promise<UploadPhotoPayload>
}

export const updatePost = (params: UpdatePost): Promise<UploadPhotoPayload> => {
    return getWrapper(
        '/ephemeral/update/',
        formDataToRequestParams<UpdatePost>(params),
        true
    ) as Promise<UploadPhotoPayload>
}

export const postDenounce = (params: { id: number; message?: string }): Promise<LikeResponse> => {
    return getWrapper(
        '/ephemeral/denounce',
        formDataToRequestParams<{ id: number }>(params),
        true
    ) as Promise<LikeResponse>
}

export const postLikePost = (params: { id: number }): Promise<LikeResponse> => {
    return getWrapper(
        '/ephemeral/like/',
        formDataToRequestParams<{ id: number }>(params),
        true
    ) as Promise<LikeResponse>
}

export const postLikePostCancel = (params: { id: number }): Promise<LikeResponse> => {
    return getWrapper(
        '/ephemeral/like/cancel',
        formDataToRequestParams<{ id: number }>(params),
        true
    ) as Promise<LikeResponse>
}

export const uploadEphemeralMaterial = async (
    params: UploadContributionMaterial,
    onUploadProgress: (id: string, progressEvent: ProgressEvent) => void
): Promise<{ info: EphemeralUploadVideoPayload }> => {
    const axios = getAxios()
    return await axios.request({
        method: 'post',
        onUploadProgress: (progressEvent) => {
            //@ts-ignore
            onUploadProgress(params.id, progressEvent)
        },
        url: '/ephemeral/upload/',
        baseURL: `${process.env.RAZZLE_UPLOAD_URL + getLangFromUrl()}/b`,
        cancelToken: params.source.token,
        data: formDataToRequestParams<UploadContributionMaterial>(params, true, true)
    })
}

export const getPendingEphemeralMaterial = (id: number): Promise<EphemeralUploadVideoPayloadGet> => {
    return getWrapper(`/ephemeral/upload/get/?id=${id}`) as Promise<EphemeralUploadVideoPayloadGet>
}

export const getPendingEphemeralList = (): Promise<EphemeralUploadVideoPayloadListPayload> => {
    return getWrapper(`/ephemeral/upload/list/`) as Promise<EphemeralUploadVideoPayloadListPayload>
}

export const deletePendingEphemeralMaterial = (id: number): Promise<EphemeralUploadVideoPayloadGet> => {
    return getWrapper(`/ephemeral/upload/delete/?id=${id}`) as Promise<EphemeralUploadVideoPayloadGet>
}
